export const DEFAULT_PDF_ZOOM = 1.75;
